import tlds from 'tlds' with { type: 'json' }

const tldsSet = new Set(tlds)

export function isEmailSyntaxValid(candidate: string): boolean {
  if (candidate.endsWith('contactt@gmail.com')) {
    // scrapper pattern
    // https://orus-insurance.slack.com/archives/C02GDHPF1RR/p1752049021948769
    return false
  }

  const isValidRegex = EMAIL_REGEX.test(candidate)
  if (candidate.length > 255 || !isValidRegex) return false

  const tld = candidate.split('.').at(-1)
  if (!tld) return false
  return tldsSet.has(tld)
}

const EMAIL_REGEX =
  // eslint-disable-next-line no-control-regex
  /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/
